import React from 'react';
import { styled } from '@compiled/react';
import { useBrowserStorageCleanup } from '../../../../controllers/browser-storage-cleanup/index.tsx';
import { useIsIssueRestoreSaving } from '../../../../controllers/is-issue-restore-saving/index.tsx';
import { useIssueRestoreMetaSubscriptions } from '../../../../controllers/issue-restore-meta/index.tsx';
import { useShouldShowBrowserWarning } from '../../../../controllers/should-show-browser-warning/index.tsx';
import { useInProgressIssueSubscriptions } from '../../../../controllers/use-in-progress-issue-subscriptions/index.tsx';

export const BackgroundActions = () => {
	// Initialise subscriptions
	useInProgressIssueSubscriptions();
	useIssueRestoreMetaSubscriptions();

	useBrowserStorageCleanup();
	useShouldShowBrowserWarning();

	const isSaving = useIsIssueRestoreSaving();
	/**
	 * This invisible div is to allow cypress tests to know whether or not we are saving data
	 */
	return (
		<InvisibleDiv
			data-testid={
				isSaving
					? 'issue-create-restore.ui.issue-restore.in-progress-initialiser.saving'
					: 'issue-create-restore.ui.issue-restore.in-progress-initialiser.not-saving'
			}
		/>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const InvisibleDiv = styled.div({
	display: 'none',
});
